import { render, staticRenderFns } from "./CommunityExpenses.vue?vue&type=template&id=3a2fab94&scoped=true&"
import script from "./CommunityExpenses.vue?vue&type=script&lang=js&"
export * from "./CommunityExpenses.vue?vue&type=script&lang=js&"
import style0 from "./CommunityExpenses.vue?vue&type=style&index=0&id=3a2fab94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2fab94",
  null
  
)

export default component.exports